import React from 'react';

export const AppContext = React.createContext({});
export const LayoutContext = React.createContext({});
